import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Route,
  Redirect,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import { Layout, Menu, Dropdown, Button } from "antd";
import cookie from "react-cookies";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const history = useHistory();

  useEffect(() => {}, []);

  return (
    <div className="cont-footer text-center">
      <div className="title">{t("pages.footer.title")}</div>
      <div className="subtitle mt-3">{t("pages.footer.subtitle")}</div>
    </div>
  );
};

export default Footer;
